export default "/img/UZ.a37e4fb1a5bf3f8f432cf3a35473574d.png";